import React from 'react';

import Tab, { TabProps } from '@mui/material/Tab';
import ClearIcon from '@mui/icons-material/Clear';
import styled from '@mui/material/styles/styled';
import Chip from '@mui/material/Chip';
import { IconButton } from '@mui/material';

interface TwTabProps extends TabProps {
  counter?: string;
  label: string;
  removable?: boolean;
  onRemove?: () => void;
}

const StyledChip = styled(Chip)({
  minWidth: '25px',
  height: '20px',
  color: '#7E858E',
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.2px',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  '& .MuiChip-label': {
    paddingLeft: '5px',
    paddingRight: '5px'
  }
});

const StyledTab = styled((props: TwTabProps) => <Tab disableRipple {...props} />)(() => ({
  textTransform: 'none',
  fontStyle: 'normal',
  fontWeight: 600,
  fontFamily: 'Poppins, sans-serif',
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '0.2px',
  color: 'gray.800',
  '&.MuiTab-root': {
    padding: '0 5px 0 5px',
    margin: '0 5px'
  },
  '&:hover': {
    color: '#3A4DE9'
  },
  '&.Mui-selected': {
    color: '#3A4DE9'
  }
}));

const RemoveIcon = styled(ClearIcon)({
  width: '16px',
  color: '#9CA3AF',
  cursor: 'pointer',
  '&:hover': {
    color: '#3A4DE9'
  }
});

const TwTab: React.FC<TwTabProps> = ({ removable = false, onRemove, counter, ...props }) => {
  const removeButton = (): JSX.Element => (
    <IconButton onClick={onRemove} disableRipple>
      <RemoveIcon />
    </IconButton>
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}
    >
      <StyledTab {...props} />
      {counter ? <StyledChip label={counter} /> : null}
      {removable && removeButton()}
    </div>
  );
};

export default TwTab;
